<template>
  <div>
    <div class="row" v-if="!in_modal">
      <div class="col-12">
        <h2>Add Zone</h2>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="zone.name" />
          </div>
          <!-- TODO Add Tags COMM-188 -->
          <div class="form-group">
            <label for="ddlZoneType">Zone Type</label>
            <select class="form-control" id="ddlZoneType" v-model="zone.zone_type_id">
              <option
                v-for="zone_type in filtered_zone_types"
                :key="zone_type.zone_type_id"
                v-bind:value="zone_type.zone_type_id"
              >{{ zone_type.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="inpColor">Color</label>
            <color-picker id="inpColor" v-model="zone.color"></color-picker>
          </div>
          <div class="form-group" v-if="zone.zone_type_id === 3">
            <label for="txtIp">IP</label>
            <input type="text" class="form-control" id="txtIp" v-model="zone.ip" />
          </div>
          <div class="form-group" v-if="zone.zone_type_id === 3">
            <label for="txtPort">Port</label>
            <input type="text" class="form-control" id="txtPort" v-model="zone.port" />
          </div>
          <ExtensionField
            v-if="zone.zone_type_id !== 4"
            v-model="zone.extension"
            :helper_text="'Must keep leading 6 and follow with 3 numbers. Example: 6061'"
          ></ExtensionField>
          <div class="form-group" v-if="zone.zone_type_id !== 4">
            <label for="txtHangupSeconds">Paging calls will auto hangup after x seconds</label>
            <input
              type="number"
              class="form-control"
              id="txtHangupSeconds"
              min="0"
              v-model="zone.hangup_seconds"
            />
            <small class="form-text text-muted">0 for no hangup</small>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
          <router-link :to="{ name: 'ZoneManager' }" class="btn btn-secondary" v-if="!in_modal">Cancel</router-link>
        </form>
      </div>
      <div class="col-4">
        <CurrentExtensions :default_type="'zone'"></CurrentExtensions>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Sketch } from 'vue-color'
import CurrentExtensions from '../../../components/CurrentExtensions'
import ExtensionField from '../../../components/ExtensionField'

export default {
  props: { in_modal: { type: Boolean, default: false } },
  data: function () {
    // TODO Add Tags
    return {
      zone: {
        zone_id: 0,
        zone_type_id: 1,
        name: '',
        ip: '1.1.1.1',
        port: 0,
        color: '#000000',
        extension: '6',
        hangup_seconds: 0,
        zone_devices: [],
        zone_zones: []
      }
    }
  },
  computed: {
    ...mapGetters({
      zone_types: 'allZoneTypes',
      scoped_site_id: 'scopedSiteId',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled',
      feature_multicast_enabled: 'featureMulticastEnabled',
      feature_g2_secure_enabled: 'featureG2SecureEnabled'
    }),
    filtered_zone_types: function () {
      let zoneTypes = [1, 2]

      if (this.feature_multicast_enabled) {
        zoneTypes.push(3)
      }

      if (this.feature_visual_alert_enabled) {
        zoneTypes.push(4)
      }

      if (this.feature_g2_secure_enabled) {
        zoneTypes.push(5)
      }

      return this.zone_types.filter(zt => zoneTypes.includes(zt.zone_type_id))
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getZoneTypes')
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX')
  },
  components: {
    'color-picker': Sketch,
    CurrentExtensions,
    ExtensionField
  },
  methods: {
    submit () {
      if (!this.in_modal) {
        this.$store.dispatch('addEditZone', { zone: this.zone, next: 'ZoneManager' })
      } else {
        this.$store.dispatch('addEditZone', { zone: this.zone, next: null })
        $('#genericModal').modal('hide')
      }
    }
  }
}
</script>

<style scoped>
</style>
